import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { useFormFieldErrorTranslation } from '~/hooks';

type IntakeIntakeQuoteHeaderFormProps = { disabled?: boolean };

export const IntakeQuoteHeaderForm = ({ disabled }: IntakeIntakeQuoteHeaderFormProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeQuoteStep' });
  const { errorToHelperText } = useFormFieldErrorTranslation();
  return (
    <Controller
      name="quoteReference"
      disabled={disabled}
      render={({ field, fieldState }) => {
        return (
          <TextField
            {...field}
            value={field.value || ''}
            label={t('quoteReference')}
            error={!!fieldState.error}
            helperText={errorToHelperText(fieldState.error)}
            margin="none"
            size="small"
            variant="standard"
            fullWidth
            required
          />
        );
      }}
    />
  );
};
